module.exports = __webpack_public_path__ + "img/productHSE_6.70348e33.png";